import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const OfferConditionsStepAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "offer-conditions-step" */ './offer-conditions-step'),
  componentName: 'OfferConditionsStep',
});
